/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutProfileController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Profile';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsOpen = false;
            $scope.Control.IsValid = true;
            $scope.Control.Form = {};
            $scope.Control.Loading = false;

            $scope.Control.firstLoad = true;
            $scope.Control.isEmail = false;
            $scope.Control.IsNewsletterEnabled = $element.data('newsletter');
            $scope.Control.IsRemoveGuestNewsLetterEnabled = $element.data('isremoveguestnewsletterenabled');
            $scope.Control.isInMailLists = false;
            $scope.Control.IsUnSubscribed = false;
            $scope.Control.UseEmailAsLoginName = true;
            $scope.Control.IsLoyaltyMemberNumberValid = true;
            $scope.Control.Form.CreateAccount = false;

            var $emailField = $('.form-row.email', $element);
            var $dateOfBirthField = $('input[type="text"][name="DateOfBirth"]', $element);

            var validators = [];
            var initiallyValidated = false;

            var options = {
                callback: function (value) {
                    var fieldName = $(this).data("fieldname");
                    var validate = $(this).data("validate");

                    if (validate)
                        $scope.Control.validateField('Control.Form.' + fieldName, false);
                },
                wait: 750,
                highlight: false,
                allowSubmit: false,
                captureLength: 1
            };

            $element.find("input[type = text], input[type = tel]").typeWatch(options);

            var savedData = new SavedDataState();

            $scope.Control.validateField = function (name, forceValidation) {
                if (initiallyValidated || forceValidation) {
                    _.first(_.filter(validators, function (x) { return x.name === name })).fn();
                }
            };

            validators.push({
                name: 'Control.Form.FirstName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.FirstName');
                    Validation.require($scope, 'Control.Form.FirstName').then(function (response) { }, function (error) { });
                }
            });

            validators.push({
                name: 'Control.Form.LastName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.LastName');
                    Validation.require($scope, 'Control.Form.LastName').then(function (response) { }, function (error) { });
                }
            });

            validators.push({
                name: 'Control.Form.UserName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.UserName');
                    Validation.require($scope, 'Control.Form.UserName').then(function (response) { }, function (error) { });
                }
            });

            validators.push({
                name: 'Control.Form.Email',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Email');
                    if ($scope.Model.Data.Config.IsRequiredProfileEmail) {
                        Validation.require($scope, 'Control.Form.Email').then(function (response) {
                            if ($scope.Model.Data.Config.IsValidProfileEmail) {
                                Validation.isEmail($scope, 'Control.Form.Email').then(function (response) {
                                }, function (error) { });
                            }
                        }, function (error) { });
                    } else {
                        if ($scope.Model.Data.Config.IsValidProfileEmail) {
                            Validation.isEmail($scope, 'Control.Form.Email').then(function (response) {
                            }, function (error) { });
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Phone',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Phone');
                    if ($scope.Model.Data.Config.IsRequiredProfilePhone) {
                        Validation.require($scope, 'Control.Form.Phone').then(function (response) {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ((($scope['Order'].Current.Shipping.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code === "onSite") || ($scope['Order'].Current.Billing.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code !== "onSite")) && checkoutConfig.greekPhoneValidation) {
                                $scope.Model.Data.Config.IsGreekPhone = true;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekPhone = false;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }, function (error) { });
                    } else {
                        if (checkoutConfig.phoneLocalizationEnabled) {
                            var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                            Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                            }).then(function (response) {
                            }, function (error) {
                                $scope.Control.IsOpen = true;
                            });
                        } else if ((($scope['Order'].Current.Shipping.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code === "onSite") || ($scope['Order'].Current.Billing.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code !== "onSite")) && checkoutConfig.greekPhoneValidation) {
                            $scope.Model.Data.Config.IsGreekPhone = true;
                            Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                            }).then(function (response) {
                            }, function (error) {
                                $scope.Control.IsOpen = true;
                            });
                        } else {
                            $scope.Model.Data.Config.IsGreekPhone = false;
                            Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                            }).then(function (response) {
                            }, function (error) { });
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Mobile',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Mobile');
                    if ($scope.Model.Data.Config.IsRequiredProfileMobile) {
                        Validation.require($scope, 'Control.Form.Mobile').then(function (response) {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ((($scope['Order'].Current.Shipping.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code === "onSite") || ($scope['Order'].Current.Billing.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code !== "onSite")) && checkoutConfig.greekMobileValidation) {
                                $scope.Model.Data.Config.IsGreekMobile = true;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekMobile = false;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }, function (error) { });
                    } else {
                        if (checkoutConfig.phoneLocalizationEnabled) {
                            var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                            Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                            }).then(function (response) {
                            }, function (error) {
                                $scope.Control.IsOpen = true;
                            });
                        } else if ((($scope['Order'].Current.Shipping.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code === "onSite") || ($scope['Order'].Current.Billing.Country === 'GR' && $scope['Order'].Current.DeliveryPoint.Code !== "onSite")) && checkoutConfig.greekMobileValidation) {
                            $scope.Model.Data.Config.IsGreekMobile = true;
                            Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                            }).then(function (response) {
                            }, function (error) {
                                $scope.Control.IsOpen = true;
                            });
                        } else {
                            $scope.Model.Data.Config.IsGreekMobile = false;
                            Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                            }).then(function (response) {
                            }, function (error) { });
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.SocialSecurityNumber',
                fn: function () {
                    if ($scope.Control.Form.SocialSecurityNumber !== undefined) {
                        Validation.reset($scope, 'Control.Form.SocialSecurityNumber');
                        Validation.isSocialSecurityNumber($scope, 'Control.Form.SocialSecurityNumber').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.LoyaltyMemberCardNumber',
                fn: function () {
                    if ($scope.Control.Form.LoyaltyMemberCardNumber !== undefined && $scope.Control.Form.LoyaltyMemberCardNumber !== '') {
                        if ($scope.Control.IsLoyaltyMemberNumberValid) {
                            $scope.Control.Form.LoyaltyCardNumberInvalid = false;
                        } else {
                            $scope.Control.Form.LoyaltyCardNumberInvalid = true;
                            $scope.Control.IsValid = false;
                        }
                    } else {
                        $scope.Control.Form.LoyaltyCardNumberInvalid = false;
                    }

                }
            });

            validators.push({
                name: 'Control.Form.DateOfBirth',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.DateOfBirth');
                    $scope.Control.Form.DateOfBirthRequired = false;
                    $scope.Control.Form.DateOfBirthInvalid = false;
                    $scope.Control.Form.DateOfBirthNotAllowed = false;

                    if ($scope.Model.Data.Config.IsRequiredProfileBirthDate) {
                        Validation.require($scope, 'Control.Form.DateOfBirth').then(function (response) {
                            Validation.isValidDateOfBirth($scope, 'Control.Form.DateOfBirth').then(function (response) {
                                if ($scope.Model.Data.Config.IsValidProfileBirthDate) {
                                    var minimumAllowedAge = $scope.Model.Data.Config.MinimumAllowedAge;
                                    Validation.isAgeAboveThreshold($scope, 'Control.Form.DateOfBirth', { age: minimumAllowedAge }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        }, function (error) { });
                    }
                }
            });

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;

                if (checkoutConfig.alwaysValidateProfile || (!$scope.Order.Current.IsLoggedIn && checkoutConfig.validateProfil)) {
                    if ($scope.Model.Data.Config.IsRequiredProfileFirstName)
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.FirstName' })).fn();
                    if ($scope.Model.Data.Config.IsRequiredProfileLastName)
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.LastName' })).fn();                     
                    if ($scope.Model.Data.Config.IsRequiredProfilePhone || $scope.Model.Data.Config.IsValidProfilePhone)
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Phone' })).fn();
                    if ($scope.Model.Data.Config.IsRequiredProfileMobile || $scope.Model.Data.Config.IsValidProfileMobile)
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Mobile' })).fn();
                    if (!$scope.Control.UseEmailAsLoginName) {
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.UserName' })).fn();
                    }       
                }

                if (checkoutConfig.alwaysValidateProfile || !$scope.Order.Current.IsLoggedIn) {
                    if ($scope.Model.Data.Config.IsRequiredProfileEmail || $scope.Model.Data.Config.IsValidProfileEmail)
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Email' })).fn();
                }

                if ($scope.Model.Data.Config.IsLoyaltyCardNumberVisible) {
                    _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.LoyaltyMemberCardNumber' })).fn();
                }

                if ($scope.Model.Data.Config.IsVisibleSocialSecurityNumber && checkoutConfig.validateSocialSecurityNumber) {
                    _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.SocialSecurityNumber' })).fn();
                }

                if ($scope.Model.Data.Config.IsVisibleProfileBirthDate) {
                    _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.DateOfBirth' })).fn();
                }

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }

                initiallyValidated = true;
            };

            $scope.$parent.$watch('EnableCreateAccount', function (newValue, prevValue) {
                $scope.Control.Form.CreateAccount = newValue;
                if (newValue) {
                    //if create account is enabled then validate profil
                    checkoutConfig.validateProfil = true;
                } else {
                    //if create account is NOT enabled then initialize profil and don't validate it
                    if ($scope.Control.Form.FirstName != '') {
                        $scope.Control.Form.FirstName = '';
                        Validation.reset($scope, 'Control.Form.FirstName');
                    }
                    if ($scope.Control.Form.LastName != '') {
                        $scope.Control.Form.LastName = '';
                        Validation.reset($scope, 'Control.Form.LastName');
                    }
                    if ($scope.Control.Form.Phone != '') {
                        $scope.Control.Form.Phone = '';
                        Validation.reset($scope, 'Control.Form.Phone');
                    }
                    if ($scope.Control.Form.Mobile != '') {
                        $scope.Control.Form.Mobile = '';
                        Validation.reset($scope, 'Control.Form.Mobile');
                    }
                    if ($scope.Control.Form.UserName != '') {
                        $scope.Control.Form.UserName = '';
                        Validation.reset($scope, 'Control.Form.UserName');
                    }
                    if ($scope.Control.Form.SocialSecurityNumber != '') {
                        $scope.Control.Form.SocialSecurityNumber = '';
                        Validation.reset($scope, 'Control.Form.SocialSecurityNumber');
                    }

                    //apply all changes in profil form
                    $scope.Control.applyChanges();
                    //if create account is NOT enabled then don't validate profil
                    checkoutConfig.validateProfil = false;
                }
            });

            $scope.Control.newsletterCheckboxCheck = function (state) {
                if (state == 'positive') {
                    return $scope.Control.IsNewsletterEnabled && (!$scope.Control.IsRemoveGuestNewsLetterEnabled || ($scope.Control.isEmail && $scope.Control.IsRemoveGuestNewsLetterEnabled && $scope.Control.IsUnSubscribed));
                } else if (state == 'negative') {
                    return $scope.Control.IsNewsletterEnabled && $scope.Control.IsRemoveGuestNewsLetterEnabled && $scope.Control.isEmail && !$scope.Control.isInMailLists && !$scope.Control.IsUnSubscribed;
                } else {
                    return false;
                }
            };

            $scope.Control.checkIfEmailExists = function () {
                if (validateEmail($scope.Control.Form.Email)) {
                    var url = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/Services/api/Account/CheckIfUserEmailExist?email=' + $scope.Control.Form.Email;
                    $emailField.closest('.form-row').addClass('x-loading');
                    $.ajax({
                        type: "GET",
                        url: url,
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {
                            $scope.Order.Current.CanCreateAccount = !response.data.UserExist;
                            checkoutConfig.canCreateAccount = !response.data.UserExist;
                            applyChanges();
                            $emailField.closest('.form-row').removeClass('x-loading');
                        },
                        failure: function (response) {
                        },
                        error: function (response) {
                        },
                    });
                } else {
                    $scope.Order.Current.CanCreateAccount = false;
                    checkoutConfig.canCreateAccount = false;
                }
            };

            $scope.Control.checkEmail = function () {
                if (validateEmail($scope.Control.Form.Email) && checkoutConfig.checkEmailForNewsletterSubscription) {
                    var url = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/Services/api/Account/IsSubscribedToNewsletter';
                    var data = { "email": $scope.Control.Form.Email };

                    $scope.Control.Form.Newsletter = false;
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: JSON.stringify(data),
                        dataType: 'json',
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {
                            $scope.Control.isInMailLists = response.data.isInMailLists;
                            $scope.Control.IsUnSubscribed = response.data.isUnSubscribed;
                            $scope.Control.isEmail = true;
                            applyChanges();
                        },
                        failure: function (response) {
                        },
                        error: function (response) {
                        },
                    });
                } else {
                    $scope.Control.Form.Newsletter = false;
                    $scope.Control.isEmail = false;
                }
            };

            $scope.Control.checkIfLoyaltyNumberIsValid = function () {
                if ($scope.Control.Form.LoyaltyMemberCardNumber !== undefined && $scope.Control.Form.LoyaltyMemberCardNumber !== '') {
                    var url = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/LoyaltyPoints/GetMemberByLoyaltyNumber?siteCode=' + LhApp.Context.Site.Code + '&loyaltyNumber=' + $scope.Control.Form.LoyaltyMemberCardNumber;

                    $.ajax({
                        type: "GET",
                        url: url,
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {
                                $scope.Control.IsLoyaltyMemberNumberValid = response.data.ErrorCode ? false : true;
                                $scope.Control.validateField('Control.Form.LoyaltyMemberCardNumber', true);
                                applyChanges();
                        },
                        failure: function (response) {
                        },
                        error: function (response) {
                        },
                    });
                } else {
                    $scope.Control.IsLoyaltyMemberNumberValid = true;
                    $scope.Control.validateField('Control.Form.LoyaltyMemberCardNumber', true);
                    applyChanges();
                }
            };

            $scope.Control.removeSpaces = function (loyaltyMemberCardNumber) {
                $scope.Control.Form.LoyaltyMemberCardNumber = loyaltyMemberCardNumber.replace(/\s/g, '');
            };

            $scope.Control.checkIfDateofBirthIsValid = function () {
                $scope.Control.validateField('Control.Form.DateOfBirth', true);
                applyChanges();
            };

            var applyChanges = function () {
                var deferred = $q.defer();
                var profile = CommonUtils.clone($scope.Control.Form);
                ControlService.invokeCheckout($scope, $element, 'SetProfile', profile).then(function (response) {
                    $.extend($scope.Order.Current.Profile, _.pick(profile, _.keys($scope.Order.Current.Profile)));
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $scope.Control.applyChanges = function () {

                if (!savedData.hasChanged($scope.Control.Form))
                    return;

                $('.x-checkoutshippingaddress').scope().Control.applyChanges();

                $scope.Control.Loading = true;
                applyChanges().then(function (response) {

                    $scope.setControlValue(controlName, $scope.Control.Form);

                    savedData.setData($scope.Control.Form);

                    $scope.Control.Loading = false;

                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $element.get(0).focus = function () {
                if (!$scope.Control.IsValid)
                    $('.x-invalid:first *[ng-model]', $element).focus();
                else
                    $('*[ng-model]:first', $element).focus();
            };

            $element.get(0).set = applyChanges;

            ControlService.getCheckoutData("GetProfileData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                
                if ($scope['Order'] &&
                    $scope['Order'].Current &&
                    $scope['Order'].Current.Profile)
                {
                    $scope.Control.UseEmailAsLoginName = $scope['Order'].Current.Profile.UseEmailAsLoginName;

                    $scope.Control.Form.FirstName = $scope['Order'].Current.Profile.FirstName;
                    $scope.Control.Form.LastName = $scope['Order'].Current.Profile.LastName;
                    $scope.Control.Form.UserName = $scope['Order'].Current.Profile.UserName;
                    $scope.Control.Form.Email = $scope['Order'].Current.Profile.Email;
                    $scope.Control.Form.Phone = $scope['Order'].Current.Profile.Phone;
                    $scope.Control.Form.Mobile = $scope['Order'].Current.Profile.Mobile;
                    $scope.Control.Form.Newsletter = $scope['Order'].Current.Profile.Newsletter;
                    $scope.Control.Form.LoyaltyMemberCardNumber = $scope['Order'].Current.Profile.LoyaltyMemberCardNumber;
                    $scope.Control.Form.SocialSecurityNumber = $scope['Order'].Current.Profile.SocialSecurityNumber;
                    $scope.Control.Form.DateOfBirth = $scope['Order'].Current.Profile.DateOfBirth;
                    $scope.Control.Form.CreateAccount = $scope['Order'].Current.EnableCreateAccount;
                }
                if (checkoutOverrides && checkoutOverrides.Profile && typeof checkoutOverrides.Profile.UpdateOnLoad === 'function'){
                    $scope.Control.Form = checkoutOverrides.Profile.UpdateOnLoad($scope.Control.Form, $scope['Order'].Current.Billing);
                }
                $scope.setControlValue(controlName, $scope.Control.Form);

                savedData.setData($scope.Control.Form);

                if ($scope.Control.Form.Email && $scope.Control.firstLoad) {
                    $scope.Control.checkEmail($scope.Control.Form.Email);
                    $scope.Control.checkIfEmailExists();
                }
                if ($scope.Control.firstLoad) {
                    if ($scope.Model.Data.Config.IsVisibleProfileBirthDate) {
                        if (checkoutConfig.useDatePicker) {
                            if (checkoutOverrides && checkoutOverrides.Profile && typeof checkoutOverrides.Profile.InitDatePicker === 'function') {
                                checkoutOverrides.Profile.InitDatePicker($dateOfBirthField.get(0), $scope.Control.Form.DateOfBirth);
                            }
                        }
                        $scope.Control.checkIfDateofBirthIsValid();
                    }
                }

                $scope.Control.firstLoad = false;
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            angular.element($element.get(0)).ready(function () {
                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.initPhoneLocalization === 'function') {
                    if (checkoutConfig.phoneLocalizationEnabled) checkoutOverrides.Generic.initPhoneLocalization($element.get(0), $scope);
                }
            });
        });
})();